import React, { Component } from 'react';
import '../style.css';
import WizardApp from '../scripts/wizard-app';

let a3sInstallApp;

class InstalView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loadingClass: "",
            titleClass: "title hidden",
            mainClass: "wiz-main hidden",
            progressBarClass: "wiz-progress-bar hidden",
            options: [],
            checked: 0
        }
    }

    async componentDidMount() {
        a3sInstallApp = new WizardApp();
        a3sInstallApp.start();

        await a3sInstallApp.getProducts().then((products) => {
            this.setState({
                options: products.Items,
                checked: 0
            })
        }).catch((e) => {
            console.log('Error in install view: ' + e);
        });

        this.setState({ loadingClass: "hidden" });
        this.setState({ titleClass: "title" });
        this.setState({ progressBarClass: "wiz-progress-bar" });
        this.setState({ mainClass: "wiz-main" });

    };

    InstallConfiguration = () => {

        a3sInstallApp.installConfigurations(this.state.options[this.state.checked]).then(() => {
            this.props.history.push('/finish');
        }).catch((err) => {
            console.log(err)
            if (err && err.body && err.body.message)
                this.props.history.push('/finish/' + err.body.message);
            else
                this.props.history.push('/finish/' + err);
        });
    };

    onChange(i) {
        this.setState({
            checked: i
        });
    }

    render() {
        return (
            <div className="full-height">
                <div id="background"></div>
                <noscript>
                    For full functionality of this site it is necessary to enable JavaScript. Here are the <a
                        href="http://www.enable-javascript.com/" target="_blank" rel="noopener noreferrer">instructions how to enable JavaScript in your web
                    browser</a>.
                    </noscript>

                <header>
                    <p>Analytics as a Service (A3S) Historical /&nbsp; Install</p>
                </header>
                <div className="wiz-content">
                    <div id="loading" className={this.state.loadingClass} style={{ marginTop: "30px", textAlign: "center" }}>
                        <i className="fa fa-spinner fa-spin" style={{ fontSize: "70px" }}></i>
                    </div>
                    <div className={this.state.titleClass} >
                        Installation
                        </div>

                        <ul className={this.state.progressBarClass}>
                        <li className="active">
                            <span className="txt-start">Start</span>
                        </li>
                        <li className="active current">
                            <span className="txt-install">Install</span>
                        </li>
                        <li className="">
                            <span className="txt-summary">Summary</span>
                        </li>
                    </ul>

                    <main className={this.state.mainClass}>
                        <div className="message">
                            <div className="message-title">
                                <span className="txt-create-role">Select Product</span>
                            </div>
                            <div className="message-content">
                                <div className="a3s-products">
                                    {
                                        this.state.options.map((option, i) => {
                                            console.log(option)
                                            return <label key={option.productName}>
                                                <input
                                                    type="radio"
                                                    className={this.props.className}
                                                    checked={this.state.checked === i ? true : false}
                                                    key={option.productName}
                                                    onChange={this.onChange.bind(this, i)}
                                                    value={option.productName} />
                                                <span>{option.productName}</span>
                                            </label>
                                        })
                                    }
                                </div>
                            </div>
                        </div>

                        <p>
                            <span className="txt-install-summary">These are the steps that will be automatically performed for
                                    you!</span>
                        </p>

                        <div className="message">
                            <div className="message-title">
                                <span className="txt-create-role">1. Create Roles</span>
                            </div>
                            <div className="message-content">
                                <div>
                                    <span className="txt-create-role-msg">
                                        Create roles specifically to provide access to the app.
                                        </span>
                                </div>
                            </div>
                        </div>

                        <div className="message">
                            <div className="message-title">
                                <span className="txt-create-oauthclient">
                                    2. Create OAuth Client
                                        </span>
                            </div>
                            <div className="message-content">
                                <div>
                                    <span className="txt-create-oauthclient-msg">
                                        Create OAuth Client for server-to-server communication.
                                        </span>
                                </div>
                            </div>
                        </div>

                        <div className="message">
                            <div className="message-title">
                                <span className="txt-create-eb-integration">
                                    3. Create Eventbridge Integration
                                        </span>
                            </div>
                            <div className="message-content">
                                <div>
                                    <span className="txt-create-eb-integration-msg">
                                        Create Amazon Eventbridge Integration for event-driven communication between Genesys Cloud and AWS.
                                        </span>
                                </div>
                            </div>
                        </div>

                        <p className="sink-more">
                            <span className="txt-start-install">
                                Please click the button to start the installation.
                                </span>
                        </p>

                        <button id="start" onClick={this.InstallConfiguration.bind(this)} className="wiz-btn-info right">
                            <span className="txt-install">Install</span>
                        </button>
                    </main>
                </div>
                <footer>
                </footer>
            </div>
        )
    }
};

export default InstalView;